var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "form",
      {
        staticClass: "uploader-box",
        attrs: { autocomplete: "off", scope: "form" },
        on: {
          submit: function ($event) {
            $event.preventDefault()
          },
        },
      },
      [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c("div", {
                class: _vm.msgClass,
                domProps: { innerHTML: _vm._s(_vm.msgUpload) },
              }),
              _vm._v(" "),
              _vm._t("aftermsg", function () {
                return [
                  _vm.showHelp
                    ? _c("div", { staticClass: "form-group" }, [
                        _c(
                          "a",
                          {
                            attrs: { href: "#" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.openNotes.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.$t(`${_vm.idPanel}.help.uploadInfoLink`)
                                ) +
                                "\n                        "
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                ]
              }),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c(
                  "label",
                  {
                    staticClass: "btn btn-silver btn-rounded btn-sm mx-0 mb-2",
                    class: {
                      disabled: _vm.limitFileExceeded || _vm.isDisabled,
                    },
                    attrs: { title: _vm.$t(`${_vm.idPanel}.form.addFile`) },
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t(`${_vm.idPanel}.form.files`)) +
                        " "
                    ),
                    _c("i", { staticClass: "pl-1 fas fa-plus" }),
                    _vm._v(" "),
                    _c("input", {
                      ref: _vm.idUpload,
                      attrs: {
                        type: "file",
                        name: _vm.idUpload,
                        accept: _vm.acceptTypes,
                        multiple: _vm.multiple,
                        disabled: _vm.limitFileExceeded || _vm.isDisabled,
                      },
                      on: { change: _vm.uploadFieldChange },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "d-flex flex-wrap align-items-center" },
                  [
                    _vm._l(_vm.files, function (item, index) {
                      return _c(
                        "div",
                        {
                          key: `file-${index}`,
                          staticClass:
                            "d-flex flex-nowrap align-items-center item pl-sm-3 w-100",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "delete mr-2",
                              attrs: {
                                title: _vm.$t(`${_vm.idPanel}.form.removeFile`),
                              },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.removeFileLoaded(index)
                                },
                              },
                            },
                            [_c("i", { staticClass: "fas fa-times" })]
                          ),
                          _vm._v(" "),
                          _c("i", { staticClass: "far fa-file-alt" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "text-truncate" }, [
                            _vm._v(" - " + _vm._s(item.name)),
                          ]),
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _vm.isFileSizeRestrictive &&
                    (!_vm.files || _vm.files.length == 0)
                      ? _c("small", { class: _vm.msgClass }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm.$t(`${_vm.idPanel}.help.maxFiles`, {
                                  num: _vm.maxFiles,
                                })
                              ) +
                              "\n                        "
                          ),
                        ])
                      : _vm._e(),
                  ],
                  2
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("div", { staticClass: "city-form-group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.files,
                        expression: "files",
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: {
                          required: _vm.minFiles > 0,
                          minElements: _vm.minFiles,
                        },
                        expression:
                          "{'required': minFiles>0, 'minElements': minFiles}",
                      },
                    ],
                    attrs: {
                      type: "hidden",
                      name: "files",
                      "data-vv-scope": "form",
                    },
                    domProps: { value: _vm.files },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.files = $event.target.value
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "small",
                    {
                      staticClass: "invalid-feedback",
                      class: [_vm.fnHasError("files") ? "d-block" : ""],
                    },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.fnFirstError("files")) +
                          "\n                        "
                      ),
                    ]
                  ),
                ]),
              ]),
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("div", { staticClass: "row d-flex justify-content-center" }, [
              _c("div", { staticClass: "col-12 col-sm-6" }, [
                _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-outline-tertiary btn-rounded btn-sm btn-responsive btn-block min-w-auto",
                    attrs: {
                      disabled: _vm.isDisabled || _vm.loading || !_vm.hasFiles,
                      type: "button",
                    },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.uploadFiles.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm.buttons["upload"]) +
                        "\n                        "
                    ),
                  ]
                ),
              ]),
            ]),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }